import React from "react";
import { Box, Grid, Hidden, ResizableDrawer, Stack } from "../components";
import { useState } from "react";
export const MapDrawerLayout = ({ children, sidebar, tabBar, left, bottom, top, right, leftSize = 270, topSize = 51, rightSize = 330, leftOpen = false, rightOpen = false, bottomOpen = false, topOpen = false, onLeftOpenChange, onRightOpenChange, }) => {
    const [hasBottomTransitioned, setHasBottomTransitioned] = useState(false);
    return (React.createElement(Grid, { container: true, flexWrap: "nowrap", height: "100%", sx: {
            containerType: "inline-size",
            position: "relative",
        } },
        React.createElement(Hidden, { item: true, height: "100%", breakpoint: "cmd" }, sidebar),
        React.createElement(ResizableDrawer, { onOpenChange: onLeftOpenChange, open: leftOpen, resizeDirection: "right", size: leftSize, sx: {
                maxWidth: "90%",
                minWidth: leftOpen ? 45 : 0,
                borderRight: 1,
                borderColor: (theme) => theme.palette.stroke[100],
                flexDirection: "column",
                display: "none",
                breakpoints: {
                    cmd: {
                        display: "flex",
                    },
                },
            } }, left),
        React.createElement(Grid, { height: "100%", item: true, xs: true, minWidth: 0 },
            React.createElement(Stack, { height: "100%", width: "100%" },
                React.createElement(Box, { sx: {
                        height: topOpen ? `${topSize}px` : 0,
                        borderBottom: topOpen ? 1 : 0,
                        borderColor: (theme) => theme.palette.stroke[100],
                        transition: "height 0.2s ease-in-out",
                    } }, top),
                React.createElement(Grid, { item: true, xs: true, width: "100%", display: "flex", minHeight: 0 }, children),
                React.createElement(Box, { sx: {
                        height: bottomOpen ? "50%" : 0,
                        borderTop: bottomOpen ? 1 : 0,
                        borderColor: (theme) => theme.palette.stroke[100],
                        transition: "height 0.2s ease-in-out",
                    }, onTransitionEnd: (e) => {
                        if (e.propertyName === "height") {
                            setHasBottomTransitioned(true);
                        }
                    } }, bottom === null || bottom === void 0 ? void 0 : bottom({ hasTransitioned: hasBottomTransitioned })),
                React.createElement(ResizableDrawer, { strategy: "absolute", onOpenChange: onLeftOpenChange, open: leftOpen, resizeDirection: "up", size: leftSize, sx: {
                        maxHeight: "90%",
                        minHeight: leftOpen ? "102px" : 0,
                        bottom: "61px",
                        borderTop: 1,
                        borderColor: (theme) => theme.palette.stroke[100],
                        backgroundColor: (theme) => theme.palette.background.container,
                        flexDirection: "column",
                        display: "flex",
                        breakpoints: {
                            cmd: {
                                display: "none",
                            },
                        },
                    } }, left),
                React.createElement(ResizableDrawer, { strategy: "absolute", onOpenChange: onRightOpenChange, open: false, resizeDirection: "up", size: rightSize, sx: {
                        maxHeight: "90%",
                        minHeight: rightOpen ? "50%" : 0,
                        bottom: "61px",
                        borderTop: 1,
                        borderColor: (theme) => theme.palette.stroke[100],
                        backgroundColor: (theme) => theme.palette.background.container,
                        flexDirection: "column",
                        display: "flex",
                        breakpoints: {
                            cmd: {
                                display: "none",
                            },
                        },
                    } }, right),
                React.createElement(Hidden, { breakpoint: "cmd", variant: "up" }, tabBar))),
        right && (React.createElement(ResizableDrawer, { onOpenChange: onRightOpenChange, open: rightOpen, resizeDirection: "left", size: rightSize, sx: {
                maxWidth: "90%",
                minWidth: rightOpen ? 45 : 0,
                borderLeft: 1,
                borderColor: (theme) => theme.palette.stroke[100],
                flexDirection: "column",
                display: "none",
                breakpoints: {
                    cmd: {
                        display: "flex",
                    },
                },
            } }, right))));
};
//# sourceMappingURL=MapDrawerLayout.js.map